import { inject } from "@angular/core";
import {
  CanActivateFn,
  CanActivateChildFn,
  Router,
  UrlTree,
} from "@angular/router";
import { AuthService } from "../services/auth.service";

export const authGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const token = auth.getToken();
  if (token) return true;

  return router.createUrlTree(["/account/auth/login"], {
    queryParams: { returnUrl: state.url },
  });
};

export const authChildGuard: CanActivateChildFn = (_route, state) => {
  // reutiliza exactamente la misma lógica
  return authGuard(_route, state);
};
